import Module from './Module';
import Table from './Table';

type RelatedRecord = Record<string, unknown> | Array<unknown> | null | undefined;

interface RelatedTicketProps {
  tickets: Array<[string, RelatedRecord]>;
}

const toRows = (record: RelatedRecord): Array<[string, string]> => {
  if (!record) return [];

  if (Array.isArray(record)) {
    return record
      .filter(Boolean)
      .map((item: any) => {
        const id = String(item?.id ?? item?.ticket_id ?? item?.key ?? '');
        const name = String(item?.name ?? item?.title ?? item?.subject ?? '');
        return [id, name] as [string, string];
      })
      .filter(([id, name]) => id && name);
  }

  if (typeof record === 'object') {
    return Object.entries(record)
      .map(([id, name]) => [String(id), String((name as any) ?? '')] as [string, string])
      .filter(([id, name]) => id && name);
  }

  return [];
};

const RelatedTickets = ({ tickets }: RelatedTicketProps) => {
  const normalized = tickets
    .map(([label, record]) => [label, toRows(record)] as const)
    .filter(([, rows]) => rows.length > 0);

  if (normalized.length === 0) return null;

  return (
    <Module
      title="Related Tickets"
      content={[
        normalized.map(([ticket, rows]) => [
          ticket,
          <Table
            headers={[
              { size: '20%', text: 'ID' },
              { size: '70%', text: 'Name' },
            ]}
            rows={rows}
          />,
        ]),
      ]}
      contentBreak
    />
  );
};

export default RelatedTickets;
